var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showGhostSchedule)?_c('div',{staticClass:"gb-ghost-schedule",style:(_vm.styleGhostSchedule)},[_c('div',{staticClass:"schedule"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }